import { CompanyDetailsPlansTab } from './CompanyDetailsPlansTab';

export function CompanyDetailsSubscriptionTab() {
  return <CompanyDetailsPlansTab />;
}
